const baseUrl = process.env.VUE_APP_API_URL;

export default {
    async login(credentials) {
        let response = await fetch(baseUrl + '/fit-summit/login',
            {
                method: "POST",
                body: JSON.stringify(credentials),
                headers: {
                    'Content-Type': 'application/json',
                }
            })
        if (response.status == 200) {
            return response.json();
        }
        else {
            return Promise.reject(response);
        }
    },

    async getLeaderBoard(data) {
        let response = await fetch(baseUrl + '/fit-summit/upload-user-details-and-get-leaderboard',
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('login')).accessToken
                }
            })
        if (response.status == 200) {
            return response.json();
        }
        else {
            return Promise.reject(response);
        }
    },
    async refreshToken() {
        let response = await fetch(baseUrl + '/active-health/web-refresh-token',
            {
                method: "POST",
                body: localStorage.getItem('login') ?? null,
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            })
        if (response.status == 200) {
            return response.json();
        }
        else {
            return Promise.reject(response);
        }
    },
    async getAllIdsVideos(videosId) {
        const data = await fetch(`${baseUrl}/user-videos`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('login')).accessToken
            },
            method: 'POST',
            body: JSON.stringify(
                videosId
            )
        });
        if (data.status == 200)
            return data.json();
        return Promise.reject(data);
    }
}
